export enum CARD_INFO_ENUM {
    AI_DEV_INFO = 'ai development',
    HEALTHCARE_MARKETING = 'healthcare marketing',
    APP_MARKETING = 'app marketing',
    BUSINESS_MOBILE_CONSULTING = 'business mobile consulting',
    AEO_MARKETING = 'aeo marketing'
}

export interface ICardInfoData {
    icon: string;
    title: string;
    text: string;
}

export interface ICardWithBulletsData {
    icon: string;
    title: string;
    subtitle: string;
    bullets: string[];
    outro?: string
}

export interface IContentSection {
    headingHtml: string;                          // lowercase; may embed <span class="gradient-text">…</span>
    lead: string[];                               // 1+ intro paragraphs
    bullets?: string[];                           // optional flat bullet list
    steps?: { term: string; detail: string }[];   // optional labelled list (term + description)
    outro?: string[];                             // optional closing paragraph(s)
}